export const DefaultTheme = {
    primary: '#BF1B2C',
    secondary1: '#CF7A82',
    secondary2: '#D9DDE7'
}

export const blueTheme = {
    primary: '#3454D1',
    secondary1: '#7191D0',
    secondary2: '#FFFBFF'
}